import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function StickyCta() {
  const { ref, inView } = useInView({
    // Hide when the user is already looking at the RSVP form area
    threshold: 0.1,
    rootMargin: '100px 0px 0px 0px'
  });

  const scrollToRsvp = (e) => {
    e.preventDefault();
    document.getElementById('rsvp')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Invisible trigger located at the RSVP section */}
      <div ref={ref} className="absolute bottom-[200px] w-full h-10 pointer-events-none" id="rsvp-trigger"></div>
      
      <AnimatePresence>
        {!inView && (
          <motion.div 
            initial={{ y: 100 }}
            animate={{ y: 0 }}
            exit={{ y: 100 }}
            className="fixed bottom-0 left-0 w-full p-4 z-50 md:hidden"
          >
            <a 
              href="#rsvp" 
              onClick={scrollToRsvp}
              className="flex items-center justify-center w-full bg-burgundy text-ivory py-5 px-6 font-sans text-[11px] uppercase tracking-[0.3em] shadow-2xl backdrop-blur-md active:scale-95 transition-all"
            >
              <span className="mr-3 w-1.5 h-1.5 rounded-full bg-floral-apricot"></span>
              RSVP • AUGUST 23
              <span className="ml-3 w-1.5 h-1.5 rounded-full bg-floral-coral"></span>
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}